export default "__VITE_ASSET__BfNy55dC__"